export const AUTO_HIDE_COOKIE_KEY = "headerInjector-autoHide"
export const HEADER_VALUE_COOKIE_KEY = "headerInjector-value"
export const HEADER_KEY = "x-branch-name"
export const URL_QUERY_PARAM_KEY = "injectOnDemandHeader"
